import { captureException } from "@sentry/browser";
import React, { useLayoutEffect } from "react";
import { useRouteError } from "react-router";

import ChunkLoadErrorFallback, { shouldAttemptChunkReload } from "components/ChunkLoadErrorFallback";

const RouterErrorElement = (): JSX.Element => {
  const error = useRouteError();

  useLayoutEffect(() => {
    if (!error) return;

    if (shouldAttemptChunkReload(error)) return;

    captureException(error);
  }, [error]);

  return <ChunkLoadErrorFallback error={error} />;
};

export default RouterErrorElement;
